import type { TourSection } from './types';

export const vehicleModelsListSections: TourSection[] = [
  {
    id: 'filters',
    label: 'Buscar modelos',
    steps: [
      {
        target: '[data-tour="vm-filters"]',
        title: 'Buscar modelos',
        content:
          'Busca por nombre del modelo (ej: "TTR 200") o por marca (ej: "Yamaha"). Esta lista contiene los modelos de moto que se pueden asociar a los productos como aplicaciones compatibles.',
      },
    ],
  },
  {
    id: 'table',
    label: 'Listado de modelos',
    steps: [
      {
        target: '[data-tour="vm-table"]',
        title: 'Tabla de modelos',
        content:
          'Cada fila muestra nombre, marca, cilindrada y año. Click en el modelo para editarlo. Los modelos creados aquí aparecen disponibles cuando agregas "Aplicaciones" a un producto.',
      },
    ],
  },
];

export const vehicleModelsFormSections: TourSection[] = [
  {
    id: 'autocompletes',
    label: 'Marca y nombre',
    steps: [
      {
        target: '[data-tour="vm-form-brand"]',
        title: 'Marca',
        content:
          'Empieza a escribir y te sugiere marcas ya existentes para que no haya duplicados. Si escribes una marca nueva, se crea al guardar.',
      },
      {
        target: '[data-tour="vm-form-name"]',
        title: 'Nombre del modelo',
        content:
          'Sugiere modelos ya cargados de esa marca para evitar duplicados. Si escribes uno nuevo, se crea al guardar.',
      },
    ],
  },
  {
    id: 'cylinders-year',
    label: 'Cilindrada y año',
    steps: [
      {
        target: '[data-tour="vm-form-displacement"]',
        title: 'Cilindrada y año',
        content:
          'Datos opcionales que sirven para diferenciar variantes del mismo modelo (ej: una 150cc del 2024 vs una 200cc del 2025).',
      },
    ],
  },
  {
    id: 'aliases',
    label: 'Nombres alternativos',
    steps: [
      {
        target: '[data-tour="vm-form-aliases"]',
        title: 'Aliases',
        content:
          'Nombres alternativos del modelo (ej: "TTR200", "TTR-200", "ttr 200"). Sirven para que el sistema reconozca el mismo modelo aunque venga escrito distinto desde las fuentes externas (master, sap, vtex). Escribe cada alias y presiona Enter para agregarlo.',
      },
    ],
  },
];
